import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../common/customHttp.service';
import { ApiUrl } from '../../common/apiUrls';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MainAppComponent } from '../../layout/layout.component';
import {EquipmentSearchFields } from '../../common/viewModels/GlobalRegistry/SampPointModel';
import { PageEvent } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { PagerService } from '../../common/pagerService';


declare var $: any;
@Component({
  selector: 'equipment',
  templateUrl: './equipment.component.html',
  styleUrls: ['./equipment.component.scss']
})
export class Equipment implements OnInit {
  equipmentForm: FormGroup;
  equipmentSearchForm: FormGroup;
  id: number;
  searchFields: EquipmentSearchFields = new EquipmentSearchFields();
  isNoRecords: boolean = true;
  isSubmitted: boolean = false;
  pager: any = {};
  pagedItems: any[];
 // pageResult: PageResultDto;
  pageIndex: number = 0;
  length: number = 0;
  pageSize: number = 0;
  pageSizeOptions = [10, 25];
  pageEvent: PageEvent;
  mainComponent: any;  
  $element: any;
  $content: any;
 
  constructor(public _router: Router, private _formBuilder: FormBuilder, private _pagerService: PagerService,
    private _http: CustomHttp,
    private _appUrl: ApiUrl, private _route: ActivatedRoute,
    private _mApp: MainAppComponent, private _toastrService: ToastrService) {
    this.mainComponent = _mApp;
  }

  ngOnInit() {
    this.pager.pageSize = this._mApp.pageSize;
    this.pager.pageIndex = 0;
    this.pager.pageSizeOptions = this._pagerService.pageSizeOptions;
    this.pageSize = this._pagerService.pageSize;
    this.CreateForm();
    this.equipmentSearchForm = this._formBuilder.group({
      Name: [''],
      EquipmentId: [0],
    });
    this.BindStaticSearchData();
    this.setPage(this.pager);    
  }
  CreateForm() {
    this.equipmentForm = this._formBuilder.group({
      EquipmentId: [0],
      Name: ['', Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(100)])],
    });
  }

  BindStaticSearchData() {
    this.searchFields.PageNo = 0;
    this.searchFields.PageSize = this._pagerService.pageSize;
  }

  setPage(page: any) {
    this.pager.pageSize = page.pageSize;
    this.pager.pageIndex = page.pageIndex;
    this.GetEquipmentsList(this.pager);
  }

  GetEquipmentsList(page: any) {
    this.searchFields.PageNo = page.pageIndex;
    this.searchFields.PageSize = page.pageSize
    this._mApp.ShowLoader();
    this._http.post(this._appUrl.GetEquipmentList, this.searchFields)
      .subscribe(
      res => {
        var data = res.json();
        this.length = data.PageResult.TotalRecords;
        this.pageSize = data.PageResult.PageSize;
        this.pageIndex = data.PageResult.PageNo;
        this.pagedItems = data.Result;
        this.isNoRecords = !(data.Result.length > 0);
        this._mApp.HideLoader();
      },
      error => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, '');
      }
      );
  }

  GetEquipmentById(id: number) {
    this._mApp.ShowLoader();   
    this._http.get(this._appUrl.GetEquipmentById + id)
      .subscribe(
      m => {
        this._mApp.HideLoader();
        if (m.json().Result != null) {
          this.equipmentForm.setValue(m.json().Result);
        }
      }, error => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, '');
      }
      )
  }

  DeleteEquipment(id: any) {
    this.id = id;
  }


  DeleteEquipmentById(id: number) {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.DeleteEquipment + id)
      .subscribe(
      res => {
        this._mApp.HideLoader();
        this.setPage(this.pager);
        this._toastrService.success(res.json().Result, '');
      },
      error => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, '');
      }
      );
  }

  onSearchSubmit() {
    this.pager.pageIndex = 0;
    let searchDto = this.equipmentSearchForm.value;
    if (searchDto.Name != null)
      this.searchFields.Name = searchDto.Name;
    this.setPage(this.pager);
  }

  onSubmit() {
    this.isSubmitted = true;
    if (this.equipmentForm.valid) {
      let unitsDto = this.equipmentForm.value;
      this._mApp.ShowLoader();
      this._http.post(this._appUrl.UpsertEquipment, unitsDto)
        .subscribe(
        data => {
          this._mApp.HideLoader();
          this._toastrService.success(data.json().Result, '');
          $('#addEquipmentModel').modal('toggle');
          this.Clear();
          this.setPage(this.pager);

        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
        );
    }
    else {
      $('#unitName').addClass("mat-input-invalid");
    }
  }

  Clear() {
    this.equipmentForm.reset();
    this.CreateForm();
    this.RemoveInvalidCSS();
  }
  RemoveInvalidCSS() {
    $('#unitName').removeClass("mat-input-invalid");
  }

  OnReset() {
    this.equipmentSearchForm.reset();
    this.pager.pageSize = this._mApp.pageSize;
    this.pager.pageIndex = 0;
    this.searchFields.Name = '';
    this.setPage(this.pager);
  }
}
